import { useIsMounted } from "@ofqual/portal-core/core/hooks";
import { useEffect, useState } from "react";

export const useUpdatingButtonText = (
  isSubmitting: boolean | undefined | null,
  isSubmitted: boolean | undefined | null,
  lifecycleLabels: [string, string, string],
  savingLabelDuration: number
) => {
  // If we hit the page with a record that has previously been saved, whatever
  //  flag that it uses to say that it is submitted may still be set to true
  //  (e.g. successCrudResult()) and so we SAVED as the first label on page load.
  // To combat this, a simple thing we can do is to make sure that before we allow
  //  a SAVED label to be shown, we make sure we have seen a normal label at some
  //  point first.
  const [haveSeenNormalMode, setHaveSeenNormalMode] = useState(false);

  const [save, saving, saved] = lifecycleLabels;
  const [text, setText] = useState("");

  const isMountedRef = useIsMounted();

  const safeSetText = (textToSet: string) => {
    if (isMountedRef.current) {
      setText(textToSet);
    }
  };

  useEffect(() => {
    if (isSubmitting) {
      safeSetText(saving);
    } else if (haveSeenNormalMode && isSubmitted) {
      safeSetText(saved);
      setTimeout(() => safeSetText(save), savingLabelDuration);
    } else {
      setHaveSeenNormalMode(true);
      safeSetText(save);
    }
  }, [!!isSubmitting, !!isSubmitted, save, saving, saved]);

  return text;
};
